export default "__VITE_ASSET__CtXpyGYw__"